function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Decimal from 'decimal.js';
import { StagesValueType } from "../../../models";
export const getDisabledReasonTooltip = disabledReason => {
  if (!disabledReason) return undefined;
  return {
    existingServiceInAgreement: "Stages can't be modified. To make changes, remove this service and add a new one to the agreement."
  }[disabledReason];
};
export const calculateStages = _ref => {
  let {
    length,
    totalRate,
    valueType
  } = _ref;
  const total = isValueTypeDollars(valueType) ? totalRate : new Decimal(100);
  const baseValue = total.div(length).toDecimalPlaces(2);
  const stages = Array(length).fill(undefined).map((_, index) => ({
    stageNumber: index + 1,
    value: new Decimal(baseValue)
  }));
  setFinalStage(stages, valueType, totalRate);
  return stages;
};
export const addStage = stages => {
  const insertIndex = stages.length - 1;
  return [...stages.slice(0, insertIndex), {
    stageNumber: insertIndex + 1,
    value: new Decimal(0)
  }, ...stages.slice(insertIndex).map(stage => _objectSpread(_objectSpread({}, stage), {}, {
    stageNumber: stage.stageNumber + 1
  }))];
};
export const removeStage = (stages, indexToRemove) => {
  const removedStage = stages[indexToRemove];
  const newStages = stages.filter((_, index) => index !== indexToRemove).map((stage, index) => _objectSpread(_objectSpread({}, stage), {}, {
    stageNumber: index + 1
  }));
  const lastStageIndex = newStages.length - 1;
  newStages[lastStageIndex] = _objectSpread(_objectSpread({}, newStages[lastStageIndex]), {}, {
    value: newStages[lastStageIndex].value.plus(removedStage.value)
  });
  return newStages;
};
export const isValueTypeDollars = valueType => valueType === StagesValueType.Amount;
export const isValueTypePercent = valueType => valueType === StagesValueType.Percent;
export const valueTypeTextMap = {
  [StagesValueType.Percent]: '%',
  [StagesValueType.Amount]: '$'
};
export const setFinalStage = (stages, valueType, totalRate) => {
  const total = isValueTypeDollars(valueType) ? totalRate : new Decimal(100);
  const stagesSum = stages.slice(0, -1).reduce((acc, stage) => acc.plus(stage.value), new Decimal(0));
  const lastStageValue = total.minus(stagesSum);
  if (stagesSum.gt(total)) return;
  stages[stages.length - 1] = _objectSpread(_objectSpread({}, stages[stages.length - 1]), {}, {
    value: lastStageValue.toDecimalPlaces(2)
  });
};
export const getHelperText = (stage, isLast, valueType, totalRate, totalSumExceedsRate) => {
  if (isValueTypePercent(valueType) && stage.value.gte(100)) return 'Exceeds 100%';
  if (isValueTypeDollars(valueType) && stage.value.gt(totalRate)) return 'Exceeds service total';
  if (isValueTypePercent(valueType) && !isLast && totalSumExceedsRate) return 'Exceeds 100%';
  if (isValueTypeDollars(valueType) && !isLast && totalSumExceedsRate) return 'Exceeds service total';
  if (isLast && stage.value.eq(0)) return 'Last payment cannot be empty';
  if (stage.value.eq(0)) return 'Insert amount';
  return undefined;
};